export const faqTypes = {
  // FAQ
  FETCH_FAQ_LIST_START: 'FETCH_FAQ_LIST_START',
  SET_FAQ_LIST: 'SET_FAQ_LIST',
  FETCH_SINGLE_FAQ_START: 'FETCH_SINGLE_FAQ_START',
  ADD_NEW_FAQ_START: 'ADD_NEW_FAQ_START',
  UPDATE_FAQ_START: 'UPDATE_FAQ_START',
  TOGGLE_FAQ_ENABLE: 'TOGGLE_FAQ_ENABLE',
  SET_FAQ_STATUS_LOADING: 'SET_FAQ_STATUS_LOADING',
  UPDATE_FAQ_ENABLE_START: 'UPDATE_FAQ_ENABLE_START',
  SET_UPDATED_FAQ: 'SET_UPDATED_FAQ',
  SET_ON_EDIT_FAQ: 'SET_ON_EDIT_FAQ',
  SET_PAGE_AND_PAGESIZE_DATA: 'SET_PAGE_AND_PAGESIZE_DATA',
  RESTART_ON_EDIT_FAQ: 'RESTART_ON_EDIT_FAQ',
  FETCH_MORE_FAQ_LIST: 'FETCH_MORE_FAQ_LIST',

  // QUESTION
  FETCH_QUESTION_START: 'FETCH_QUESTION_START',
  ADD_NEW_QUESTION_START: 'ADD_NEW_QUESTION_START',
  SORT_QUESTIONS_START: 'SORT_QUESTIONS_START',
  UPDATE_QUESTION_START: 'UPDATE_QUESTION_START',
  DELETE_QUESTION_START: 'DELETE_QUESTION_START',
  DELETE_FAQ_START: 'DELETE_FAQ_START',
  DELETE_FAQ: 'DELETE_FAQ',
  CREATE_EMPTY_QUESTION: 'CREATE_EMPTY_QUESTION',
  SET_ON_EDIT_QUESTION: 'SET_ON_EDIT_QUESTION',
  SET_QUESTIONS_LIST: 'SET_QUESTIONS_LIST',
  SET_QUESTION_DATA: 'SET_QUESTION_DATA',
  TOGGLE_QUESTION_EXPAND: 'TOGGLE_QUESTION_EXPAND',
};
